import { LCDClient, Msg } from "@terra-money/feather.js";
import { CLASSIC_CHAIN_ID, TOKEN_DETAIL_KEY } from "./Constants";

export function formatAddress(address: string) {
    return address.substring(0, 8) + '...' + address.substring(address.length - 4)
}

export const paste = async (onRead: (text: string) => void) => {
    try {
        const text = await navigator.clipboard.readText();
        onRead(text)
    } catch (err) {
        console.error('Failed to read clipboard contents: ', err);
    }
}

export const copy = async (text: string) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch (err) {
        console.error('Failed to write content to clipboard: ', err);
    }
}

export const fromDenom = (amount: number, decimals: number) => {
    return amount / Math.pow(10, decimals)
}

export const toDenom = (amount: number, decimals: number = 6) => {
    return amount * Math.pow(10, decimals)
}

export const numberPendek = (num: number): string => {
    if (num >= 1_000_000_000_000) {
        return Math.round(num / 1_000_000_000_000).toFixed(1).replace(/\.0$/, '') + 'T';
    }
    if (num >= 1_000_000_000) {
        return Math.round(num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    }
    if (num >= 1_000_000) {
        return Math.round(num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1_000) {
        return Math.round(num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return currency(num)
};

export const formatTxHash = (str: string, startLength: number = 6, endLength: number = 6) => {
    if (str.length <= startLength + endLength) {
        return str; // If the string is shorter or equal to the combined length, return as is.
    }
    const start = str.substring(0, startLength);
    const end = str.substring(str.length - endLength);
    return `${start}...${end}`;
}

export const currency = (value: number) => {
    return new Intl.NumberFormat("us", {
        maximumFractionDigits: 6
    }).format(value)
}

export const lcd = new LCDClient({
    [CLASSIC_CHAIN_ID]: {
        chainID: CLASSIC_CHAIN_ID,
        prefix: "terra",
        gasPrices: {
            uluna: 28.325,
            usdr: 0.52469,
            uusd: 0.75,
            ukrw: 850,
            umnt: 2142.855,
            ueur: 0.625,
            ucny: 4.9,
            ujpy: 81.85,
            ugbp: 0.55,
            uinr: 54.4,
            ucad: 0.95,
            uchf: 0.7,
            uaud: 0.95,
            usgd: 1,
            uthb: 23.1,
            usek: 6.25,
            unok: 6.25,
            udkk: 4.5,
            uidr: 10900,
            uphp: 38,
            uhkd: 5.85,
            umyr: 3,
            utwd: 20
        },
        lcd: "https://lcd-terraclassic.tfl.foundation/",
        gasAdjustment: 1.5
    }
})

export const saveTokenDetails = (tokens: string) => {
    sessionStorage.setItem(TOKEN_DETAIL_KEY, tokens)
}

export const getTokenDetails = () => {
    const tokens = sessionStorage.getItem(TOKEN_DETAIL_KEY)
    if (tokens) return tokens
    return "[]"
}

export const getValidatorLogo = (validatorAddress: string) => {
    switch (validatorAddress) {
        case "terravaloper18kdk2kf8uvzs5gghky23hv4q7wdnk0ff2etv7c":
            return "https://s3.amazonaws.com/keybase_processed_uploads/97b5111d46556ae302579fd74761e405_360_360.jpg"
            break;
    }
}